import { Link } from 'react-router-dom';
import { Plane, Train, Car, Search, Shield, Lock, Star, Arrow, Calendar, Check } from '../Icons';

const results = [
  { name: 'Traveller A••••', Mode: Plane, modeLabel: 'Flight', date: '14 Oct', capacity: '8 kg', rating: 4.9, trips: 23 },
  { name: 'Traveller R••••', Mode: Train, modeLabel: 'Train', date: '15 Oct', capacity: '5 kg', rating: 4.8, trips: 11 },
  { name: 'Traveller S••••', Mode: Car, modeLabel: 'Car', date: '16 Oct', capacity: '15 kg', rating: 5.0, trips: 7 },
];

export default function Hero() {
  return (
    <section className="hero" id="top">
      <div className="hero__bg" aria-hidden="true">
        <div className="blob blob--a" />
        <div className="blob blob--b" />
        <div className="grid-lines" />
      </div>

      <div className="container hero__inner">
        <div className="hero__copy reveal">
          <span className="eyebrow">
            <span className="dot" /> Peer-to-peer delivery, admin-verified
          </span>
          <h1>
            Send anything with people <span className="gradient-text">already going there.</span>
          </h1>
          <p className="lead">
            Routebag matches your luggage, parcels and documents with verified travellers on the same
            route. Personal details stay private, payment is held securely, and every match is reviewed
            and assigned by our team.
          </p>
          <div className="hero__actions">
            <Link to="/register?role=sender" className="btn btn--primary btn--lg">
              Send an item <Arrow width={18} height={18} />
            </Link>
            <Link to="/become-a-traveller" className="btn btn--outline btn--lg">
              I'm travelling
            </Link>
          </div>
          <ul className="hero__trust">
            <li><Check width={16} height={16} /> Contact details stay hidden</li>
            <li><Check width={16} height={16} /> Admin-reviewed assignment</li>
            <li><Check width={16} height={16} /> Secure payment</li>
          </ul>
        </div>

        <div className="hero__visual reveal" style={{ '--delay': '120ms' }}>
          <div className="mock" role="img" aria-label="Example search showing travellers from Mumbai to Dubai with masked names and available capacity">
            <div className="mock__head">
              <div className="mock__dots"><i /><i /><i /></div>
              <span>Find a traveller</span>
            </div>

            <div className="mock__search">
              <div className="field">
                <small>From</small>
                <strong>Mumbai</strong>
              </div>
              <div className="field__swap"><Arrow width={14} height={14} /></div>
              <div className="field">
                <small>To</small>
                <strong>Dubai</strong>
              </div>
              <div className="field field--date">
                <small>Date</small>
                <strong><Calendar width={13} height={13} /> 14–16 Oct</strong>
              </div>
              <span className="mock__go"><Search width={18} height={18} /></span>
            </div>

            <div className="mock__results">
              {results.map((r, i) => (
                <div className={`result ${i === 0 ? 'result--active' : ''}`} key={r.name}>
                  <div className="result__avatar"><r.Mode width={18} height={18} /></div>
                  <div className="result__main">
                    <div className="result__name">
                      {r.name}
                      <span className="badge badge--ok"><Shield width={11} height={11} /> Verified</span>
                    </div>
                    <div className="result__meta">
                      {r.modeLabel} · {r.date} · <Star width={11} height={11} className="star" /> {r.rating.toFixed(1)} ({r.trips} trips)
                    </div>
                  </div>
                  <div className="result__cap">
                    <strong>{r.capacity}</strong>
                    <small>free space</small>
                  </div>
                </div>
              ))}
            </div>

            <div className="mock__foot">
              <Lock width={14} height={14} />
              <span>Name, phone and ID are shared only after admin assignment</span>
            </div>
          </div>

          <div className="float float--a">
            <span className="float__icon float__icon--green"><Shield width={18} height={18} /></span>
            <div>
              <strong>Traveller assigned</strong>
              <small>Reviewed by admin</small>
            </div>
          </div>
          <div className="float float--b">
            <span className="float__icon float__icon--indigo"><Lock width={18} height={18} /></span>
            <div>
              <strong>Payment secured</strong>
              <small>Held until assignment</small>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
